import Swal from "sweetalert2";

export default class ReschedulingAttendance {
  constructor($el, modalSchedule) {
    this.$el = $el;
    this.$modalSchedule = modalSchedule;

    if (!this.$modalSchedule)
      return;

    this.turboFrame = this.$modalSchedule.querySelector('turbo-frame');
    $(this.$modalSchedule).on('shown.bs.modal', () => this.updateTurboFrameSource());
    $(this.$modalSchedule).on('hidden.bs.modal', () => this.clear());
  }

  edit(enrollmentId, serviceId, src) {
    this.enrollmentId = enrollmentId;
    this.serviceId = serviceId;
    this.src = src;
    this.attendanceCard = document.querySelector(`.attendance-card[data-enrollment-id="${this.enrollmentId}"]`);

    $(this.$modalSchedule).modal('show');
  }

  clear() {
    this.enrollmentId = this.serviceId = undefined;
    document.querySelector('body').classList.toggle('calendar', false);
  }

  updateTurboFrameSource() {
    this.$modalSchedule.querySelector('.modal-header .modal-title').innerHTML = `<div class="line-clamp-1">Novo horário para <span class="font-capitalize">${this.attendanceCard.dataset.enrollmentName}</span></div>`;
    this.turboFrame.setAttribute('src', `${this.src}&service_id=${this.serviceId}&object_name=${this.attendancesName}[rescheduled_to_attributes]`);
    document.querySelector('body').classList.toggle('calendar', true);
  }

  askToRemoveRescheduling(select) {
    this.attendanceCard = select.closest('.attendance-card');

    this.askConfirmation().then(async (result) => {
      if (!result.value) {
        select.value = 'false';
        return;
      }

      this.removeRescheduling(this.attendanceCard);
      this.attendanceCard.querySelector('.rescheduling-attributes').insertAdjacentHTML('afterBegin', this.generateAttendanceAttrHiddenInput('_destroy', '1'));
      await Swal.fire({
        text: 'Tudo certo, reagendamento será removido da lista de presença.',
        type: 'success',
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-secondary mr-3'
        },
        buttonsStyling: false,
      });
      this.$el.closest('form').submit();
    });
  }

  askConfirmation() {
    return Swal.fire({
      title: 'Tem certeza disso?',
      text: "Essa aula já foi reagendada. A aula desse aluno voltará para o horário padrão do contrato.",
      type: 'warning',
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-green-500 mr-3'
      },
      buttonsStyling: false,
      animation: false,
      showCancelButton: true,
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  removeRescheduling(attendanceCard) {
    delete attendanceCard.dataset.rescheduled;
    attendanceCard.querySelector('.rescheduling-attributes').innerHTML = '';
  }

  generateAttendanceAttrHiddenInput(name, value) {
    return `<input type="hidden" name="${this.attendancesName}[rescheduled_to_attributes][${name}]" value="${value}" />`;
  }

  get attendancesName() { return this.attendanceCard.querySelector('.presences').getAttribute('name').match(/(appointment\[attendances_attributes\]\[.*?\])/)[0]; }
}